<script setup>
import { computed } from "vue";
import { formatearInputMoneda } from "@/utils/helpers";
import { useUsuarioStore } from "../../../../store/usuarioStore";

const usuarioStore = useUsuarioStore();

function getColorClass(monto) {
  return Number(monto) > 0 ? "estado-pill--success" : "estado-pill--danger";
}

const saldoClass = computed(() =>
  getColorClass(usuarioStore?.resumenGarantias?.saldo)
);

const ofertadoClass = computed(() =>
  getColorClass(usuarioStore?.resumenGarantias?.ofertado)
);


const creditoClass = computed(() => {
  const credito = usuarioStore.resumenGarantias.credito;

  if (credito === null || credito > 0)
    return "estado-pill--success estado-pill--success-bg";

  return "estado-pill--danger";
});

</script>

<template>
  <div class="d-flex flex-column flex-lg-row gap-3 py-4">
    <!-- SALDO -->
    <span
      class="estado-pill border-primary text-primary d-flex align-items-center justify-content-between w-100"
      :class="saldoClass"
    >
      <span>Saldo</span>
      <span class="ms-2">
        $ {{ formatearInputMoneda(parseFloat(usuarioStore.resumenGarantias?.saldo)) }}
      </span>
    </span>

     <!-- PENDIENTE -->
    <span
      class="estado-pill  estado-pill-warning d-flex align-items-center justify-content-between w-100"
     
    >
      <span>Saldo Pendiente</span>
      <span class="ms-2">
        $ {{ formatearInputMoneda(parseFloat(usuarioStore.resumenGarantias?.saldo_pendiente)) }}
      </span>
    </span>

    <!-- OFERTADO -->
    <span
      class="estado-pill d-flex align-items-center justify-content-between w-100"
      :class="ofertadoClass"
    >
      <span>Ofertado</span>
      <span class="ms-2">
        $ {{ formatearInputMoneda(usuarioStore.resumenGarantias.ofertado ?? 0) }}
      </span>
    </span>

    <span
      class="estado-pill border-primary text-primary bg-soft-grey d-flex align-items-center justify-content-between w-100"
      :class="creditoClass"
    >
      <span>
        <span>Crédito</span>
      </span>

      <span class="ms-2" v-if="usuarioStore.resumenGarantias.credito === null">
        Sin tope
      </span>
      <span class="ms-2" v-else>
        $ {{ formatearInputMoneda(usuarioStore.resumenGarantias.credito) }}
      </span>
    </span>
  </div>
</template>

<style scoped>
.estado-pill {
  height: 42px;
  padding: 0 0.9rem;
  border-radius: 5px;
  border: 2px solid transparent;
  background-color: #ffffff;
  font-weight: 700;
  font-size: 0.9rem;
}

.estado-pill--danger {
  border-color: #ff6b6b;
  color: #ff6b6b;
}

.estado-pill-warning {
  border-color: #FFC96C;
  color: #FFC96C;
}

.estado-pill--success {
  border-color: #1f7a4d;
  color: #1f7a4d;
}

.estado-pill--success-bg {
  background-color: rgba(0, 108, 76, 0.11);
}
</style>
